/**
 * Briques partagées par l'onglet « Aide MCP » du Compte (`McpHelpPanel`) et par la page publique
 * `/aide-mcp` (`pages/AideMcpPage.jsx`) : une cellule de planche B et un bloc d'extrait copiable.
 * Extraites ici pour que les deux écrans ne les réécrivent pas.
 */

import { CopyButton } from './CopyButton.jsx';
import { CELL_PLANCHE } from '../ui/theme.js';

/** Cellule fermée d'une planche B (`CELLS_PLANCHE`), équerres comprises. */
export function McpCell({ span = 'md:col-span-3', children }) {
  return (
    <div className={`${CELL_PLANCHE} bg-paper p-4 ${span}`}>
      <span className="ticks" aria-hidden="true" />
      {children}
    </div>
  );
}

/** Extrait de code ou de configuration, suivi de son bouton « Copier ». */
export function SnippetBlock({ value }) {
  return (
    <>
      <pre className="mt-2 whitespace-pre-wrap break-all border-2 border-line bg-paper p-3 font-mono text-xs text-ink">
        {value}
      </pre>
      <CopyButton value={value} className="mt-2" />
    </>
  );
}
